import styled from 'styled-components';

import colors from 'utils/colors';

export const MenuContent = styled.div`
  width: 100%;
  box-sizing: border-box;
  background-color: ${colors.darkGrey};
  color: ${colors.white};
  display: flex;
`;
